<template>
  <div id="app" class="guide-utilisateur">
    <section class="has-bg-light">
      <customHeader></customHeader>
      <search></search>
      <div class="container">
        <div class="columns">
          <navbar></navbar>
          <router-view/>
        </div>
      </div>
    </section>
    <customFooter></customFooter>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Search from './components/Search.vue'
import CustomHeader from './components/CustomHeader.vue'
import CustomFooter from './components/CustomFooter.vue'
import './styles/css/app.css'
import { objectPage, objectRubric } from './utils.js'
const contentful = require('contentful')

export default {
  name: 'App',
  components: {
    Navbar,
    Search,
    CustomHeader,
    CustomFooter
  },
  created () {
    let token = this.$route.query.token
    if (token === null || token === undefined) {
      token = localStorage.getItem('token')
    }
    if (token) {
      localStorage.setItem('token', token)
      token = window.atob(token)
      this.$store.commit('setToken', {
        token: token
      })
    }
    this.loadRubrics()
  },
  methods: {
    loadRubrics () {
      const client = contentful.createClient({
        space: '1gymb3e2piir',
        accessToken:
          'afd209d71174301d3271784f835a4b2583bf61cf6a3b9b2eba12ff61f0ef3c5d'
      })
      this.$store.commit('setContentfullClient', {
        client: client
      })
      client.getEntries({ content_type: 'faqSubject', include: 2 }).then(response => {
        let rubrics = []
        response.items.forEach(e => {
          let item = e
          let rubric = {}
          rubric = objectRubric(item)
          if (item.fields.contents) {
            item.fields.contents.forEach(f => {
              rubric.pages.push(objectPage(f))
            })
          }
          let doublon = rubrics.find(function (x) {
            return x.name === rubric.name
          })
          if (doublon === null || doublon === undefined) {
            rubrics.push(rubric)
          } else if (doublon.revision < rubric.revision) {
            let index = rubrics.indexOf(doublon)
            rubrics[index] = rubric
          }
        })
        this.$store.commit('setRubrics', {
          rubrics: rubrics
        })
      }).catch(console.error)
    }
  }
}
</script>
